import React from 'react';

import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';

import { useFulfillmentPlanIdContext } from '../../../../../../../fulfillment-plans/context/fulfillment-plan-id-context-provider';
import { useModal } from '../../../../../../../hooks/use-modal';
import { EditAmountSummaryModal } from '../edit-amount-summary';
import { useHasFulfillmentPlanRestriction } from '../../../../restrictions-context';
import { UiRestrictions } from '../../../../../../../enums/component-states';
import messages from '../messages';

import style from '../style.module.less';
import buttonTextStyle from 'ui-components/components/button/button-text.module.less';

const AmountSummaryLabel = () => {
  const { open, close, isOpen } = useModal();
  const fulfillmentPlanId = useFulfillmentPlanIdContext();
  const isRestricted = useHasFulfillmentPlanRestriction(UiRestrictions.AmountSummary);

  return (
    <div className={style['amount-summary-label']}>
      <FormattedMessage {...messages.costSummary} />
      {!isRestricted && (
        <Button className={buttonTextStyle['button-text']} onClick={open} theme='link'>
          <FormattedMessage {...messages.editAmounts} />
        </Button>
      )}
      {isOpen && <EditAmountSummaryModal fulfillmentPlanId={fulfillmentPlanId} onClose={close} />}
    </div>
  );
};

export { AmountSummaryLabel };
